import { fromJS } from 'immutable'
import {
  REPORT_LEAVE_HISTORY_EXPORT_REQUEST,
  REPORT_LEAVE_HISTORY_EXPORT_SUCCESS,
  REPORT_LEAVE_HISTORY_EXPORT_FAILURE,
  REPORT_LEAVE_HISTORY_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_LEAVE_HISTORY_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_LEAVE_HISTORY_EXPORT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('url', fromJS(action.payload.url))
        .set('status', 200)
    case REPORT_LEAVE_HISTORY_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('url', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case REPORT_LEAVE_HISTORY_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
        .delete('status')
        .delete('message')
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-leave-history-export-reducer.js